import TableCell from './TableCell';
import { RichTextCellFields } from './tableSpotTypes';

type RichTextCellProps = {
  cell: RichTextCellFields;
  background: string;
  colspan?: number;
};

const RichTextCell = ({ cell: { content }, ...rest }: RichTextCellProps) => {
  return (
    <TableCell {...rest}>
      <span dangerouslySetInnerHTML={{ __html: content?.value || '' }} />
    </TableCell>
  );
};

export default RichTextCell;
